// Add your JS customizations here

// Sticky Header Functionality
window.addEventListener("scroll", function () {
  const header = document.querySelector("header");
  const body = document.body;
  if (header) {
    if (window.scrollY > 50) {
      header.classList.add("sticky");
      const headerHeight = header.offsetHeight;
      body.style.paddingTop = headerHeight + "px";
    } else {
      header.classList.remove("sticky");
      body.style.paddingTop = "0px";
    }
  }
});

// Menu Functionality
const hamburgerBtn = document.querySelector(".hamburger-btn"),
  closeBtn = document.querySelector(".close-btn"),
  mobileHeaderNav = document.querySelector(".mobile-header-nav");

if (hamburgerBtn && closeBtn && mobileHeaderNav) {
  const toggleMenu = (show) => {
    mobileHeaderNav.classList.toggle("d-block", show);
  };

  hamburgerBtn.addEventListener("click", () => toggleMenu(true));
  closeBtn.addEventListener("click", () => toggleMenu(false));
}

// Video Functionality
const videoBlocks = document.querySelectorAll(".has-play-button");

videoBlocks.forEach((videoBlock) => {
  const video = videoBlock.querySelector("video");

  videoBlock.addEventListener("click", () => {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });

  video.addEventListener("play", () => {
    videoBlock.classList.remove("has-play-button");
  });

  video.addEventListener("pause", () => {
    videoBlock.classList.add("has-play-button");
  });
});

// Function to update gravity form required text
function updateRequiredText() {
  document.querySelectorAll(".gfield_required_text").forEach((el) => {
    el.textContent = "*";
  });
}
// Pause all other videos except the one playing
function pauseOtherVideos(currentVideo) {
  document.querySelectorAll(".wp-block-video video").forEach((video) => {
    if (video !== currentVideo && !video.paused) {
      video.pause();
    }
  });
}

function playVideo() {
  document.querySelectorAll(".wp-block-video video").forEach((video) => {
    // Desktop click
    video.addEventListener("click", function () {
      pauseOtherVideos(this);

      if (this.paused) {
        this.play();
      } else {
        this.pause();
      }
    });

    // Mobile touch
    video.addEventListener(
      "touchstart",
      function () {
        pauseOtherVideos(this);

        if (this.paused) {
          this.play();
        } else {
          this.pause();
        }
      },
      { passive: true },
    );
  });
}

document.addEventListener("DOMContentLoaded", updateRequiredText);
document.addEventListener("DOMContentLoaded", playVideo);
document.addEventListener("click", (event) => {
  const button = event.target.closest(".read-more-toggle-btn a");
  if (!button) return;
  const card = button.closest(".is-team-card");
  if (!card) return;
  card.classList.toggle("is-expanded");
  button.textContent = card.classList.contains("is-expanded")
    ? "Read Less"
    : "Read More";
});
